import { render, staticRenderFns } from "./playItem.vue?vue&type=template&id=788c64ae&scoped=true&"
import script from "./playItem.vue?vue&type=script&lang=ts&"
export * from "./playItem.vue?vue&type=script&lang=ts&"
import style0 from "./playItem.vue?vue&type=style&index=0&id=788c64ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788c64ae",
  null
  
)

export default component.exports